import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import { concatDeserializeMappers, deserializeWithMappers, setFieldValues } from 'stores/Utils';
import ColorStore from 'stores/Model/ColorStore';
import BaseBlockStore from '../BaseBlockStore';
import constants from 'Constants';


class DividerBlockStore extends BaseBlockStore {

  @setter @observable heightPx;
  @setter @observable widthPct;
  @setter @observable color;
  @setter @observable lineType;

  static create(data={}) {
    const instance = new DividerBlockStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return Object.assign({}, BaseBlockStore.getDefaults(), {
      "heightPx": "",
      "widthPct": "",
      "color": new ColorStore(),
      "lineType": "",
    });
  }

  constructor(defaults=DividerBlockStore.getDefaults()) {
    super(defaults);
  }

  reset(defaults=DividerBlockStore.getDefaults()) {
    super.reset(defaults);
  }

  getDeserializeMappers() {
    let mappers = [
      {"field": "heightPx", "accessor": "height_px"},
      {"field": "widthPct", "accessor": "width_pct"},
      {"field": "color", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ColorStore},
      {"field": "lineType", "accessor": "line_type"},
    ];

    return concatDeserializeMappers(super.getDeserializeMappers(), mappers);
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get lineTypeCss() {
    const option = constants.DIVIDER_LINE_TYPE_OPTIONS.filter((option) => option.value === this.lineType)[0];
    if (!option) return "";
    return option.css_value;
  }

  @computed get cssAttributes() {
    let attrs = {
      "width": `${this.widthPct}%`,
      "margin": 'auto',
      "border-top": 'none',
      "border-left": 'none',
      "border-right": 'none',
      "border-bottom": `${this.heightPx}px ${this.lineTypeCss} ${this.color.css}`,
    };

    return attrs;
  }
}


export default DividerBlockStore;
